export default "__VITE_ASSET__DtT4BW_d__"